import type { TimerProfileSchedule } from "../components/types";

/** Formats a "HH:mm" time string into a 12-hour display, e.g. "19:00 (PM)". */
export function formatTime(time: string): string {
  if (!time) return "";
  const [hours, minutes] = time.split(":").map(Number);
  const period = hours >= 12 ? "PM" : "AM";
  const displayHours = hours % 12 || 12;
  return `${displayHours}:${minutes.toString().padStart(2, "0")} ${period}`;
}

/** Parses a backend time string (e.g. "11:45 (11:45 (AM))" or "19:00") into the "HH:mm" format expected by <input type="time">. */
export function parseTimeToHHmm(time?: string | null): string {
  if (!time) return "";
  const match = time.match(/(\d{1,2}):(\d{2})/);
  if (!match) return "";
  return `${match[1].padStart(2, "0")}:${match[2]}`;
}

/** Builds the human-readable schedule summary shown in the table and restore rows. */
export function formatScheduleSummary(schedule: TimerProfileSchedule): string {
  const span = `${schedule.startTime} - ${schedule.endTime}`;
  return schedule.validAllDay
    ? `${span} • Valid All Day`
    : `${span} • ${schedule.days.join(", ")}`;
}

export type TimerProfileCommandResultRow = {
  zoneId: number | null;
  zoneName?: string;
  schedule: string;
  dimLevel: number | null;
  brightLevel: number | null;
  action: string;
  status: string;
};